import { ROUTES_CLIENT, TypeNameBlocks } from '@/utils/constants';
import {
  // DynamicPageSection,
  TypeParameter,
} from '@/components/common/Providers/GraphqlProvider/generated';

export function getInputNameFromTypename(typename: string) {
  switch (typename) {
    case TypeNameBlocks.PAGE_SLIDER_BLOCK:
      return 'sliderBlock';
    case TypeNameBlocks.PAGE_TAXES_BLOCK:
      return 'taxesBlock';
    case TypeNameBlocks.PAGE_SNS_BLOCK:
      return 'snsBlock';

    case TypeNameBlocks.PAGE_NEWSLETTER_BLOCK:
      return 'newsletterBlock';
    case TypeNameBlocks.PAGE_INSTITUTIONAL_PROGRAMS_BLOCK:
      return 'institutionalProgramsBlock';
    case TypeNameBlocks.PAGE_PROCEDURES_BLOCK:
      return 'proceduresBlock';
    case TypeNameBlocks.PAGE_REGULATIONS_BLOCK:
      return 'regulationsBlock';
    case TypeNameBlocks.PAGE_CABINET_BLOCK:
      return 'cabinetBlock';
    case TypeNameBlocks.PAGE_SOCIAL_NETWORKS_BLOCK:
      return 'socialNetworksBlock';
    case TypeNameBlocks.PAGE_EVENTS_BLOCK:
      return 'eventsBlock';
    case TypeNameBlocks.PAGE_TRANSPARENCY_BLOCK:
      return 'transparencyBlock';
    case TypeNameBlocks.PAGE_TRANSPARENCY_HEADER_BLOCK:
      return 'transparencyHeaderBlock';
    case TypeNameBlocks.PAGE_TRANSPARENCY_ACCORDION_BLOCK:
      return 'transparencyAccordionBlock';
    case TypeNameBlocks.PAGE_PARTICIPATES_DOWNLOAD_BLOCK:
      return 'participateDownloadBlock';
    case TypeNameBlocks.PAGE_PARTICIPATES_HEADER_BLOCK:
      return 'participateHeaderBlock';
    case TypeNameBlocks.PAGE_PARTICIPATES_ELEMENT_BLOCK:
      return 'participateElementBlock';
    case TypeNameBlocks.PAGE_PROCEDURES_HEADER_BLOCK:
      return 'procedureHeaderBlock';
    case TypeNameBlocks.PAGE_PROCEDURES_CARD_BLOCK:
      return 'procedureMainBlock';
    case TypeNameBlocks.PAGE_PROCEDURES_AREA_BLOCK:
      return 'procedureFeedbackBlock';
    case TypeNameBlocks.PAGE_INSTITUTIONAL_PROGRAM_BLOCK:
      return 'institutionalProgramsBlock';
    case TypeNameBlocks.PAGE_INSTITUTIONAL_PROGRAM_CAROUSEL:
      return 'institutionalProgramsSliderBlock';
    case TypeNameBlocks.PAGE_SUBHEADER_BLOCK:
      return 'subHeaderBlock';
    case TypeNameBlocks.PAGE_PQRSD_ACTION_BLOCK:
      return 'pqrsdfActionBlock';
    case TypeNameBlocks.PAGE_PQRSD_CONSULT_BLOCK:
      return 'pqrsdfConsultBlock';
    default:
      return '';
  }
}

export function getBlockNameByTypename(typename: string | undefined) {
  switch (typename) {
    case TypeNameBlocks.PAGE_HEADER_BAR:
      return 'Barra de acceso general (GOVCO)';
    case TypeNameBlocks.PAGE_AUTHENTICATION_BAR:
      return 'Barra de autenticación';
    case TypeNameBlocks.PAGE_NAVIGATION_BAR:
      return 'Menú principal de navegación';
    case TypeNameBlocks.PAGE_ACCESSIBILITY_BAR:
      return 'Botón / Widget de Accesibilidad';
    case TypeNameBlocks.PAGE_FOOTER_BAR:
      return 'Pie de Página GOV.CO';
    case TypeNameBlocks.PAGE_SLIDER_BLOCK:
      return 'Carrusel';
    case TypeNameBlocks.PAGE_TAXES_BLOCK:
      return 'Botón de acceso a impuestos';
    case TypeNameBlocks.PAGE_SNS_BLOCK:
      return 'Redes sociales';
    case TypeNameBlocks.PAGE_NEWSLETTER_BLOCK:
      return 'Panel de noticias';
    case TypeNameBlocks.PAGE_INSTITUTIONAL_PROGRAMS_BLOCK:
      return 'Programas institucionales';
    case TypeNameBlocks.PAGE_PROCEDURES_BLOCK:
      return 'Gestión de trámites y servicios destacados';
    case TypeNameBlocks.PAGE_REGULATIONS_BLOCK:
      return 'Normativas';
    case TypeNameBlocks.PAGE_DOWNLOAD_REGULATIONS_BLOCK:
      return 'Descargables';
    case TypeNameBlocks.PAGE_CABINET_BLOCK:
      return 'Gabinete';
    case TypeNameBlocks.PAGE_SOCIAL_NETWORKS_BLOCK:
      return 'Redes y publicidad';
    case TypeNameBlocks.PAGE_EVENTS_BLOCK:
      return 'Eventos';
    case TypeNameBlocks.PAGE_QUICK_ACCESS_BAR:
      return 'Bloque de enlaces';
    case TypeNameBlocks.PAGE_EVENTS_SLIDER:
      return 'Slider de Eventos';
    case TypeNameBlocks.PAGE_ATTENTION_LINES_BLOCK:
      return 'Líneas de atención';
    case TypeNameBlocks.PAGE_TRANSPARENCY_HEADER_BLOCK:
      return 'Cabecera de sección';
    case TypeNameBlocks.PAGE_TRANSPARENCY_BLOCK:
      return 'Introducción';
    case TypeNameBlocks.PAGE_TRANSPARENCY_ACCORDION_BLOCK:
      return 'Acordeón';
    case TypeNameBlocks.PAGE_CORPORATE_LOGOS:
      return 'Franja de Logos Institucionales';
    case TypeNameBlocks.PAGE_PRESS_ROOM_BLOCK:
      return 'Cabecera de sección';
    case TypeNameBlocks.PAGE_PARTICIPATES_HEADER_BLOCK:
      return 'Cabecera de sección';
    case TypeNameBlocks.PAGE_PARTICIPATES_ELEMENT_BLOCK:
      return 'Elementos de participa';
    case TypeNameBlocks.PAGE_PARTICIPATES_DOWNLOAD_BLOCK:
      return 'Descargables';
    case TypeNameBlocks.PAGE_PROCEDURES_HEADER_BLOCK:
      return 'Cabecera de sección';
    case TypeNameBlocks.PAGE_PROCEDURES_CARD_BLOCK:
      return 'Tarjetas de trámites y servicios';
    case TypeNameBlocks.PAGE_PROCEDURES_AREA_BLOCK:
      return 'Área de servicios';
    case TypeNameBlocks.PAGE_HEADER_ORGANIZATION_BLOCK:
      return 'Encabezado institucional';
    case TypeNameBlocks.PAGE_INSTITUTIONAL_PROGRAM_BLOCK:
      return 'Filtros de programas';
    case TypeNameBlocks.PAGE_INSTITUTIONAL_PROGRAM_CAROUSEL:
      return 'Carrusel';
    case TypeNameBlocks.PAGE_SUBHEADER_BLOCK:
      return 'Cabecera';
    case TypeNameBlocks.PAGE_ACCORDION_REGULATIONS:
      return 'Acordión';
    case TypeNameBlocks.PAGE_PQRSD_ACTION_BLOCK:
      return 'Acciones de PQRSDF';
    case TypeNameBlocks.PAGE_PQRSD_CONSULT_BLOCK:
      return 'Informes y notificaciones';
    case TypeNameBlocks.PAGE_CUSTOM_BLOCK:
      return 'Bloque personalizado';
    case TypeNameBlocks.PAGE_ACCORDION_BLOCK:
      return 'Acordeón';
    case TypeNameBlocks.PAGE_ALERTS_BLOCK:
      return 'Bloque de alerta';
    case TypeNameBlocks.PAGE_ACCESSIBILITY_BUTTON:
      return 'Botón de accesibilidad';
    case TypeNameBlocks.PAGE_SEARCH_BLOCK:
      return 'Bloque de busqueda';
    case TypeNameBlocks.PAGE_MAP_BLOCK:
      return 'Mapa interactivo';
    default:
      return '';
  }
}

export function getBlockDescriptionByTypename(typename: string | undefined) {
  switch (typename) {
    case TypeNameBlocks.PAGE_HEADER_BAR:
      return 'Sección fija en la parte superior que incluye enlaces esenciales como el cambio de idioma (ES/EN), el botón de inicio de sesión y registro de usuario, junto con el logotipo de GOV.CO.';
    case TypeNameBlocks.PAGE_AUTHENTICATION_BAR:
      return 'Barra de autenticación';
    case TypeNameBlocks.PAGE_NAVIGATION_BAR:
      return 'Contiene los enlaces organizados para acceder a las secciones clave del portal. Es una guía estructurada para que el usuario navegue fácilmente por los contenidos del sitio web.';
    case TypeNameBlocks.PAGE_ACCESSIBILITY_BAR:
      return 'Ícono flotante que despliega herramientas de asistencia (alto contraste, aumento de fuente, navegación por teclado, lector de pantalla, etc.) para cumplir la navegación inclusiva y accesible.';
    case TypeNameBlocks.PAGE_FOOTER_BAR:
      return 'Bloque inferior de color institucional que concentra la información de contacto (NIT, dirección, teléfonos, horarios, correos, redes sociales) y los emblemas oficiales. Incluye la barra azul GOV.CO y el crédito “Desarrollado por CS3”.';
    case TypeNameBlocks.PAGE_SLIDER_BLOCK:
      return 'Carrusel';
    case TypeNameBlocks.PAGE_TAXES_BLOCK:
      return 'Botón de acceso a impuestos';
    case TypeNameBlocks.PAGE_SNS_BLOCK:
      return 'Redes sociales';
    case TypeNameBlocks.PAGE_NEWSLETTER_BLOCK:
      return 'Panel de noticias';
    case TypeNameBlocks.PAGE_INSTITUTIONAL_PROGRAMS_BLOCK:
      return 'Programas institucionales';
    case TypeNameBlocks.PAGE_PROCEDURES_BLOCK:
      return 'Gestión de trámites y servicios destacados';
    case TypeNameBlocks.PAGE_REGULATIONS_BLOCK:
      return 'Normativas';

    case TypeNameBlocks.PAGE_DOWNLOAD_REGULATIONS_BLOCK:
      return 'Descargables';
    case TypeNameBlocks.PAGE_CABINET_BLOCK:
      return 'Gabinete';
    case TypeNameBlocks.PAGE_SOCIAL_NETWORKS_BLOCK:
      return 'Redes y publicidad';
    case TypeNameBlocks.PAGE_EVENTS_BLOCK:
      return 'Eventos';
    case TypeNameBlocks.PAGE_QUICK_ACCESS_BAR:
      return 'Bloque de enlaces';
    case TypeNameBlocks.PAGE_EVENTS_SLIDER:
      return 'Slider de Eventos';

    case TypeNameBlocks.PAGE_ATTENTION_LINES_BLOCK:
      return 'Líneas de atención';
    case TypeNameBlocks.PAGE_TRANSPARENCY_HEADER_BLOCK:
      return 'Cabecera de sección';
    case TypeNameBlocks.PAGE_TRANSPARENCY_BLOCK:
      return 'Introducción';
    case TypeNameBlocks.PAGE_TRANSPARENCY_ACCORDION_BLOCK:
      return 'Acordeón';
    case TypeNameBlocks.PAGE_CORPORATE_LOGOS:
      return 'Muestra, en un carrusel automático, los logotipos de los organismos aliados.';
    case TypeNameBlocks.PAGE_PRESS_ROOM_BLOCK:
      return 'Cabecera de sección';
    case TypeNameBlocks.PAGE_PARTICIPATES_HEADER_BLOCK:
      return 'Cabecera de sección';
    case TypeNameBlocks.PAGE_PARTICIPATES_ELEMENT_BLOCK:
      return 'Elementos de participa';
    case TypeNameBlocks.PAGE_PARTICIPATES_DOWNLOAD_BLOCK:
      return 'Descargables';
    case TypeNameBlocks.PAGE_PROCEDURES_HEADER_BLOCK:
      return 'Cabecera de sección';
    case TypeNameBlocks.PAGE_PROCEDURES_CARD_BLOCK:
      return 'Tarjetas de trámites y servicios';
    case TypeNameBlocks.PAGE_PROCEDURES_AREA_BLOCK:
      return 'Área de servicios';
    case TypeNameBlocks.PAGE_HEADER_ORGANIZATION_BLOCK:
      return 'Componente visual donde se presenta el nombre oficial de la entidad, los escudos representativos de la entidad, la región y la nación, y su jurisdicción. Establece identidad y contexto territorial.';
    case TypeNameBlocks.PAGE_INSTITUTIONAL_PROGRAM_BLOCK:
      return 'Filtros de programas';
    case TypeNameBlocks.PAGE_INSTITUTIONAL_PROGRAM_CAROUSEL:
      return 'Carrusel';
    case TypeNameBlocks.PAGE_SUBHEADER_BLOCK:
      return 'Cabecera';

    case TypeNameBlocks.PAGE_ACCORDION_REGULATIONS:
      return 'Acordión';
    case TypeNameBlocks.PAGE_PQRSD_ACTION_BLOCK:
      return 'Acciones de PQRSDF';
    case TypeNameBlocks.PAGE_PQRSD_CONSULT_BLOCK:
      return 'Informes y notificaciones';
    case TypeNameBlocks.PAGE_CUSTOM_BLOCK:
      return 'Bloque personalizado';
    default:
      return '';
  }
}

export function getDynamicRouteValue(value: string) {
  const route = `/${value}`;
  const routeValues = Object.values(ROUTES_CLIENT);
  if (routeValues.includes(route)) {
    return route;
  }
  return '/';
}

export function getSystemParametersType() {
  return [
    { label: 'Texto', value: TypeParameter.Character },
    { label: 'Texto largo', value: TypeParameter.LongCharacter },
    { label: 'Número', value: TypeParameter.Number },
    { label: 'Booleano', value: TypeParameter.Boolean },
    { label: 'JSON', value: TypeParameter.Json },
    { label: 'Fecha', value: TypeParameter.Date },
    { label: 'Imagen', value: TypeParameter.Image },
  ];
}

// export function getDynamicPageSection(value: DynamicPageSection | null | undefined) {
//   if (!value) {
//     return 'General';
//   }
//   switch (value) {
//     case DynamicPageSection.Participate:
//       return 'Participa';
//     case DynamicPageSection.General:
//       return 'General';
//   }
// }

export function normalizeUrl(url: string): string {
  const httpRegex = /^(https?:\/\/)/;
  const slashRegex = /^(\/)/;

  if (httpRegex.test(url)) {
    return url;
  }

  if (slashRegex.test(url)) {
    return url;
  }

  return `//${url}`;
}

export type TableItemAction<T, P> = {
  type: T;
  payload: P;
};
export function formatSize(bytes: any, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
